<template>
  <div class="grid grid-cols-2 gap-2">
    <div class="relative w-full">
      <select required class="block w-full appearance-none sm:text-sm border border-gray-300 pl-2 pr-8 py-2 mt-2" :name="`state_${name}`" v-model="state">
        <option value="" disabled>Select a state</option>
        <option v-for="state in states" :value="state.abbr" :key="state.abbr">
          {{ state.name }}
        </option>
      </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
</svg>
              </div>
    </div>
    <div class="relative w-full">
      <select class="block w-full appearance-none sm:text-sm border border-gray-300 pl-2 pr-8 py-2 mt-2" :name="`county_${name}`" v-model="countyValue" :disabled="state === ''" :required="state !== ''">
        <option value="" disabled>Select a county</option>
        <option
          v-for="county in counties"
          :value="county"
          :key="county.name"
        >
          {{ county.name }}
        </option>
      </select>
              <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
  <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
</svg>
              </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      required: false,
      default() {
        return {
          state_abbr: '',
          name: '',
        }
      },
    },
    name: {
      type: String,
      required: true,
    },
    states: {
      type: Array,
      required: true,
    },
  },
  data: function () {
    return {
      state: "",
      counties: [],
      localValue: this.value
    };
  },
  computed: {
      countyValue: {
          get() {
              return this.localValue
          },
          set(val) {
              this.$emit('input', val)
              this.localValue = val;
          }
      }
  },
  watch: {
    state: function (value) {
      this.$http
        .get(`/Register/Counties/${value}`)
        .then((res) => {
          this.counties = res.body.data;
        })
        .catch((err) => {
          this.counties = [];
          this.error = "Unknown error while fetching counties.";
        });
    },
  },
};
</script>
